import { Control, Controller, ControllerProps, useFormContext } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export interface FormInputProps<T extends string | number>
    extends Omit<ControllerProps, 'name' | 'control' | 'render'> {
    options: { label: string; value: T }[];
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control?: Control<any, any>;
    label?: string;
}

export default function FormInputSelect<T extends string | number>({
    name,
    options,
    control,
    label,
    ...rest
}: FormInputProps<T>) {
    const { trigger } = useFormContext();
    return (
        <Controller
            {...rest}
            name={name}
            control={control}
            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                <FormControl fullWidth sx={{ marginY: 1 }}>
                    <InputLabel id={`select-label`}>{label}</InputLabel>
                    <Select
                        labelId={`select-label`}
                        id={`select`}
                        {...restField}
                        // helperText={error ? error.message : null}
                        // size="small"
                        error={!!error}
                        onChange={(e) => {
                            onChange(e);
                            // triggering Yup validation on change
                            trigger?.(name);
                        }}
                        value={value}
                        fullWidth
                        label={label}
                        variant="outlined"
                    >
                        {options.map(({ label, value }) => (
                            <MenuItem key={value} value={value}>
                                {label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        />
    );
}
